{
  "actionbar.actions": "Aktionen",
  "actionbar.actionsAvailable": "Aktionen verfügbar.",
  "actionbar.clearSelection": "Auswahl löschen",
  "actionbar.selected": "{count, plural, =0 {Keine ausgewählt} other {# ausgewählt}}",
  "actionbar.selectedAll": "Alles ausgewählt",
  "breadcrumbs.more": "Weitere Elemente",
  "button.pending": "Ausstehend",
  "combobox.noResults": "Keine Ergebnisse",
  "contextualhelp.help": "Hilfe",
  "contextualhelp.info": "Informationen",
  "dialog.alert": "Warnhinweis",
  "dialog.dismiss": "Schließen",
  "dropzone.replaceMessage": "Datei zum Ersetzen ablegen",
  "inlinealert.informative": "Informationen",
  "inlinealert.negative": "Fehler",
  "inlinealert.notice": "Warnung",
  "inlinealert.positive": "Erfolg",
  "label.(optional)": "(optional)",
  "label.(required)": "(erforderlich)",
  "menu.moreActions": "Mehr Aktionen",
  "notificationbadge.indicatorOnly": "Neue Aktivität",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Auswählen…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Laden...",
  "table.loadingMore": "Mehr laden ...",
  "table.resizeColumn": "Spaltengröße ändern",
  "table.sortAscending": "Aufsteigend sortieren",
  "table.sortDescending": "Absteigend sortieren",
  "tag.actions": "Aktionen",
  "tag.hideButtonLabel": "Weniger zeigen",
  "tag.noTags": "Keine",
  "tag.showAllButtonLabel": "Alle anzeigen ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
